var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:({
    transform: ("rotate(" + _vm.rotate + "deg)"),
    'border-left-width': (_vm.borderSideWidth + "px"),
    'border-right-width': (_vm.borderSideWidth + "px"),
    'border-bottom-width': (_vm.borderBottomWidth + "px"),
    'border-bottom-color': _vm.bg
    }),attrs:{"styleName":"triangle"}})}
var staticRenderFns = []

export { render, staticRenderFns }